var fn = function fn(JsonRPCService) {
    return {
        getCreditScore: function getCreditScore(CreditScoreRequest) {
            return JsonRPCService.send('pc', 'ama/creditscore_ama', 'getCreditScore', [CreditScoreRequest]);
        }
    };
};

fn.$inject = ['JsonRPCService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/services/CPPCreditScoreService.js
// module id = 829
// module chunks = 0